import { AICX } from './core/AICX';

export default AICX;
